export default {"src":"/_next/static/media/user.e4eb4161.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};